module.exports = __webpack_public_path__ + "pc/img/career-swiper03.912dadaf.png";